// Simple dialog open/close helpers
export function dialogClickListener(e: Event) {
    const target = e.target as HTMLElement;
    if (!target) return;

    // Close any open <details> (e.g., user account menu) when clicking outside
    document.querySelectorAll('details[open]').forEach((el) => {
        const det = el as HTMLDetailsElement;
        if (!det.contains(target)) {
            det.open = false;
        }
    });

    // Sidebar open/close
    const openSidebarEl = target.closest('[data-open-sidebar]') as HTMLElement | null;
    if (openSidebarEl) {
        const sidebar = document.getElementById('mobile-sidebar');
        const overlay = document.getElementById('mobile-sidebar-overlay');
        if (sidebar && overlay) {
            sidebar.classList.remove('translate-x-full');
            overlay.classList.remove('opacity-0', 'pointer-events-none');
            overlay.classList.add('opacity-100');
            // prevent background scroll
            document.documentElement.classList.add('overflow-hidden');
            e.preventDefault();
        }
    }

    const closeSidebarEl = target.closest('[data-close-sidebar]') as HTMLElement | null;
    if (closeSidebarEl || target.id === 'mobile-sidebar-overlay') {
        const sidebar = document.getElementById('mobile-sidebar');
        const overlay = document.getElementById('mobile-sidebar-overlay');
        if (sidebar && overlay) {
            sidebar.classList.add('translate-x-full');
            overlay.classList.add('opacity-0', 'pointer-events-none');
            overlay.classList.remove('opacity-100');
            document.documentElement.classList.remove('overflow-hidden');
            e.preventDefault();
        }
    }
}
